export default {
  "menu.welcome": "Welcome",
  "menu.more-blocks": "More Blocks",
  "menu.home": "Home",
  "menu.admin": "Admin",
  "menu.admin.sub-page": "Sub-Page",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.register-result": "Register Result",
  "menu.dashboard": "Dashboard",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "Form",
  "menu.form.basic-form": "Basic Form",
  "menu.form.step-form": "Step Form",
  "menu.form.step-form.info": "Step Form(write transfer information)",
  "menu.form.step-form.confirm": "Step Form(confirm transfer information)",
  "menu.form.step-form.result": "Step Form(finished)",
  "menu.form.advanced-form": "Advanced Form",
  "menu.list": "List",
  "menu.list.table-list": "Search Table",
  "menu.list.basic-list": "Basic List",
  "menu.list.card-list": "Card List",
  "menu.list.search-list": "Search List",
  "menu.list.search-list.articles": "Search List(articles)",
  "menu.list.search-list.projects": "Search List(projects)",
  "menu.list.search-list.applications": "Search List(applications)",
  "menu.profile": "Profile",
  "menu.profile.basic": "Basic Profile",
  "menu.profile.advanced": "Advanced Profile",
  "menu.result": "Result",
  "menu.result.success": "Success",
  "menu.result.fail": "Fail",
  "menu.exception": "Exception",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "Trigger",
  "menu.account": "Account",
  "menu.account.center": "Account Center",
  "menu.account.settings": "Account Settings",
  "menu.account.trigger": "Trigger Error",
  "menu.account.logout": "Logout",
  "menu.editor": "Graphic Editor",
  "menu.editor.flow": "Flow Editor",
  "menu.editor.mind": "Mind Editor",
  "menu.editor.koni": "Koni Editor",
  "menu.permission": "Permission",
  "menu.permission.adminList": "Admin List",
  "menu.permission.inspectorList": "Inspector List",
  "menu.userManagement": "User Management",
  "menu.userManagement.userList": "User List",
  "menu.userManagement.userDetail": "User Detail",
  "menu.userManagement.answerUnblocked": "Answer unblocked",
  "menu.userManagement.answerUnblocked.answerRecord": "Answer record",
  "menu.userManagement.blackList": "Black List",
  "menu.content": "Content",
  "menu.content.activity": "Activity",
  "menu.content.channel": "Channel",
  "menu.content.channel.config": "Channel Config",
  "menu.content.channel.list": "News List",
  "menu.content.channel.source": "Source List",
  "menu.content.common-software": "Common Software",
  "menu.content.local-offers": "Local Offers",
  "menu.content.milestone": "Milestone",
  "menu.content.public-services": "Public Services",
  "menu.content.businessCase": "Business Case",
  "menu.content.communityTheme": "Community Theme",
  "menu.content.communityReply": "Community Reply",
  "menu.review": "Review",
  "menu.review.businessExemption": "Business Exemption",
  "menu.review.thread": "Thread",
  "menu.review.thread.topic": "Topic",
  "menu.review.thread.reply": "Reply",
  "menu.review.users": "Users",
  "menu.review.users.avatar": "Avatar",
  "menu.review.users.nickName": "NickName",
  "menu.review.users.signature": "Signature",
  "menu.review.AIReview": "AI Review",
  "menu.review.AIReview.topic": "Topic",
  "menu.review.AIReview.reply": "Reply",
  "menu.review.AIReview.avatar": "Avatar",
  "menu.review.AIReview.nickName": "NickName",
  "menu.review.AIReview.signature": "Signature",
  "menu.review.riskReview": "Risk Review",
  "menu.review.riskReview.topic": "Topic",
  "menu.review.riskReview.reply": "Reply",
  "menu.review.reviewReport": "Review Report",
  "menu.review.reviewReport.report": "Report",
  "menu.review.reviewReport.appeal": "Appeal",
  "menu.review.keywordsThesaurus": "Keywords Thesaurus",
  "menu.operation": "Operation",
  "menu.operation.payActivity": "Pay Activity",
  "menu.operation.buriedPoint": "Buried Point",
  "menu.operation.recommend": "Recommend",
  "menu.operation.groupSending": "Group Sending",
};
